import { useEvaluateFeature } from "../../queries/features/UseEvaluateFeature";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { FeatureConstants } from "../../services/features-data-service/Models";
import AppHeaderV2 from "./AppHeaderV2";
import AppHeaderV1 from "./AppHeaderV1";

export type AppHeaderProps = {
    hideMenu?: boolean,
    hideLogo?: boolean,
    hideSearch?: boolean,
    //hideTools?: boolean,
    onToggleDrawer?: () => void,
};

export default function AppHeader({ 
    onToggleDrawer,
    hideMenu,
    hideLogo,
    hideSearch,
    
}: AppHeaderProps) {


    const { data: headerAndActionsV2Feature } = useQueryNotifications(useEvaluateFeature)({
        feature: FeatureConstants.HeaderAndActionsV2,
    });

    const headerAndActionsV2 = (headerAndActionsV2Feature ?? false);

    return (
        headerAndActionsV2 ?
        <AppHeaderV2 
            onToggleDrawer={onToggleDrawer}
            hideMenu={hideMenu}
            hideLogo={hideLogo}
            hideSearch={hideSearch}
        /> :
        <AppHeaderV1 
            onToggleDrawer={onToggleDrawer}
            hideMenu={hideMenu}
            hideLogo={hideLogo}
            hideSearch={hideSearch}
        />
    );
}
